import '@brig/theme/fonts';
import '@brig/theme/global.css';
import './i18n/index.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { ApiProvider } from './api/ApiProvider.tsx';
import { AuthProvider } from './auth/AuthContext.tsx';
import { router } from './router.tsx';

const root = document.getElementById('root');
if (!root) throw new Error('#root element is missing');

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <ApiProvider>
        <RouterProvider router={router} />
      </ApiProvider>
    </AuthProvider>
  </StrictMode>,
);
